
import {
    onMounted,
    ref,
    defineAsyncComponent,
 } from 'vue'; 

import useClientes from '../composables/useClientes';

export default {
    components: {
        ClienteEditarComponent: defineAsyncComponent(
            () => import('@/modules/ventas/components/ClienteEditarComponent.vue')
        ),
    },
    setup() {
        // const products = ref<any>(
        //     [
        //         {"id": "1000","code": "f230fh0g3","name": "Bamboo Watch","description": "Product Description","image": "bamboo-watch.jpg","price": 65,"category": "Accessories","quantity": 24,"inventoryStatus": "INSTOCK","rating": 5},
        //         {"id": "1001","code": "nvklal433","name": "Black Watch","description": "Product Description","image": "black-watch.jpg","price": 72,"category": "Accessories","quantity": 61,"inventoryStatus": "INSTOCK","rating": 4},
        //         {"id": "1002","code": "zz21cz3c1","name": "Blue Band","description": "Product Description","image": "blue-band.jpg","price": 79,"category": "Fitness","quantity": 2,"inventoryStatus": "LOWSTOCK","rating": 3},
        //         {"id": "1003","code": "244wgerg2","name": "Blue T-Shirt","description": "Product Description","image": "blue-t-shirt.jpg","price": 29,"category": "Clothing","quantity": 25,"inventoryStatus": "INSTOCK","rating": 5},
        //         {"id": "1004","code": "h456wer53","name": "Bracelet","description": "Product Description","image": "bracelet.jpg","price": 15,"category": "Accessories","quantity": 73,"inventoryStatus": "INSTOCK","rating": 4},
        //         {"id": "1005","code": "av2231fwg","name": "Brown Purse","description": "Product Description","image": "brown-purse.jpg","price": 120,"category": "Accessories","quantity": 0,"inventoryStatus": "OUTOFSTOCK","rating": 4},
        //         {"id": "1006","code": "bib36pfvm","name": "Chakra Bracelet","description": "Product Description","image": "chakra-bracelet.jpg","price": 32,"category": "Accessories","quantity": 5,"inventoryStatus": "LOWSTOCK","rating": 3},
        //         {"id": "1007","code": "mbvjkgip5","name": "Galaxy Earrings","description": "Product Description","image": "galaxy-earrings.jpg","price": 34,"category": "Accessories","quantity": 23,"inventoryStatus": "INSTOCK","rating": 5},
        //         {"id": "1008","code": "vbb124btr","name": "Game Controller","description": "Product Description","image": "game-controller.jpg","price": 99,"category": "Electronics","quantity": 2,"inventoryStatus": "LOWSTOCK","rating": 4},
        //         {"id": "1009","code": "cm230f032","name": "Gaming Set","description": "Product Description","image": "gaming-set.jpg","price": 299,"category": "Electronics","quantity": 63,"inventoryStatus": "INSTOCK","rating": 3}
        //     ]            
        // );
        const {
            obtenerClientes,
        } = useClientes();

        const fitroBusqueda = ref<any>({
            textoBuscar: ''
        });

        const headers = [
            { text: 'CI', value: 'carnet_identidad', sortable: true },
            { text: 'Nombre', value: 'nombre', sortable: true },
            { text: 'Celular', value: 'celular', sortable: true },
            { text: 'Correo', value: 'correo_electronico', sortable: true },
            { text: 'Dirección', value: 'direccion', sortable: true },
            { text: 'Estado', value: 'estado', sortable: true },
            { text: '', value: 'acciones', width: 15 },
        ];

        let clientes: any = [];
        const clientesFiltrados = ref<any[]>([]);

        const textoFiltro = ref<string>('');

        const clienteEditarComponentRef = ref();

        onMounted(async() => {
            await buscarClientes();
        });

        const buscarClientes = async () => {
            const resp = await obtenerClientes(fitroBusqueda.value.textoBuscar);
            if (resp.ok) {
                clientes = resp.data;
                clientesFiltrados.value = JSON.parse(JSON.stringify(clientes));
            }
        }

        const nuevoCliente = async () => {
            clienteEditarComponentRef.value.abrirComponent();
        }

        const editarCliente = async (cliente: any) => {
            clienteEditarComponentRef.value.abrirComponent(JSON.parse(JSON.stringify(cliente)));
        }

        const filtrarInformacion = async () => {
            clientesFiltrados.value = JSON.parse(JSON.stringify(
                clientes.filter(
                    (u: any) => u.carnet_identidad.toLowerCase().includes(textoFiltro.value.toLowerCase())
                        || u.nombre.toLowerCase().includes(textoFiltro.value.toLowerCase())
                        || u.celular.toLowerCase().includes(textoFiltro.value.toLowerCase())
                        || u.correo_electronico.toLowerCase().includes(textoFiltro.value.toLowerCase())
                        || u.direccion.toLowerCase().includes(textoFiltro.value.toLowerCase())
                )
            ));
        }

        const cerrarClienteEditarComponentEmit = async(seGrabo: boolean) => {
            if (seGrabo) {
                await buscarClientes();
            }
        }

        return {
            // products,
            fitroBusqueda,
            headers,
            textoFiltro,
            clientesFiltrados,

            buscarClientes,
            editarCliente,
            filtrarInformacion,
            nuevoCliente,

            clienteEditarComponentRef,
            cerrarClienteEditarComponentEmit,
        };
    }
}
